import {
  Box,
  Button,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import React, { useEffect } from "react";
import Modal from "react-awesome-modal";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { changePasswordSchema } from "./modalForms";
import { backend } from "../../../../../api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    width: "90%",
    margin: "20px auto",
  },
  modalHeading: {
    fontSize: 24,
    fontWeight: 550,
    marginBottom: 0,
  },
  modalLine: {
    margin: "20px auto",
    width: "100%",
    color: theme.palette.secondary.dark,
  },
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
}));

function ChangePasswordModal(props) {
  const { visible, closeModal, userId } = props;
  const classes = useStyles();

  const handleFormSubmit = (values) => {
    const userPassword = {
      curr_pass: values.old,
      new_pass: values.password,
    };
    backend
      .put(`/user/${userId}/password/change`, userPassword)
      .then((res) => {
        if (res.data.message === "Password Changed") {
          closeModal();
          Swal.fire({
            title: "Congratulations",
            icon: "success",
            confirmButtonText: "OK",
            text: res.data.message,
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  return (
    <Modal
      visible={visible}
      width="500"
      effect="fadeInUp"
      onClickAway={closeModal}
    >
      <div className={classes.modalContainer}>
        <h3 className={classes.modalHeading}>Change Password</h3>
        <hr className={classes.modalLine} />
        <Formik
          initialValues={{
            password: "",
            confirmPassword: "",
            old: "",
          }}
          onSubmit={(values) => handleFormSubmit(values)}
          validationSchema={changePasswordSchema}
        >
          {({ errors }) => {
            return (
              <Form>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>
                    Old Password
                  </InputLabel>
                  <Field
                    type="password"
                    name="old"
                    as={OutlinedInput}
                    fullWidth
                    error={errors.old}
                    className={classes.inputField}
                  />
                  <ErrorMessage name="old">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>
                    Password
                  </InputLabel>
                  <Field
                    type="password"
                    name="password"
                    as={OutlinedInput}
                    fullWidth
                    error={errors.password}
                    className={classes.inputField}
                  />
                  <ErrorMessage name="password">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>
                    Confirm Password
                  </InputLabel>
                  <Field
                    type="password"
                    name="confirmPassword"
                    as={OutlinedInput}
                    fullWidth
                    error={errors.confirmPassword}
                    className={classes.inputField}
                  />
                  <ErrorMessage name="confirmPassword">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button className={classes.cancelBtn} onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button className={classes.submitBtn} type="submit">
                    Update
                  </Button>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
}

export default ChangePasswordModal;
